import { TimeSeriesChartItem } from "@widgets/components";

export const getPerfVsBenchmarkData = (data: IInstrumentChartTripleData) => {
  const chartData: TimeSeriesChartItem[] = [
    {
      category: data.timeSeriesLabels?.p,
      entries: (data.timeSeries || []).map((item) => ({
        date: new Date(item.d),
        value: item.p * 100,
      })),
      color: "var(--chart-blue-color)",
    },
    {
      category: data.timeSeriesLabels?.v,
      entries: (data.timeSeries || []).map((item) => ({
        date: new Date(item.d),
        value: item.v * 100,
      })),
      color: "var(--chart-green-color)",
    },
    ...(data.timeSeriesLabels?.s
      ? [
          {
            category: data.timeSeriesLabels?.s,
            entries: (data.timeSeries || []).map((item) => ({
              date: new Date(item.d),
              value: item?.s * 100,
            })),
            color: "var(--chart-yellow-color)",
          },
        ]
      : []),
  ].filter(Boolean);

  const minValue = (data.timeSeries || [])
    .map((item) => [item.p, item.v, ...(item?.s ? [item.s] : [])])
    .filter(Boolean)
    .flat()
    .reduce((acc, curr) => Math.min(acc, curr), Infinity);

  return { chartData, minValue: Math.floor(minValue * 110) };
};
